import { render, staticRenderFns } from "./Home3Dian8_2.vue?vue&type=template&id=6b0bb740&scoped=true"
import script from "./Home3Dian8_2.vue?vue&type=script&lang=js"
export * from "./Home3Dian8_2.vue?vue&type=script&lang=js"
import style0 from "./Home3Dian8_2.vue?vue&type=style&index=0&id=6b0bb740&prod&lang=css"
import style1 from "./Home3Dian8_2.vue?vue&type=style&index=1&id=6b0bb740&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0bb740",
  null
  
)

export default component.exports